import React, { useCallback, useEffect, useMemo, useState } from "react";
import LoaderOverlay from "../../reusableComponents/Loader";
import ReactTable from "../ReactTable/ReactTable";
import axios from "axios";
import { baseUrl } from "../../utils/apis";
import { useSelector } from "react-redux";
import ReactCountryFlag from "react-country-flag";
import { resolveCountryCode, getDisplayCountryName } from "../../utils/helpers/country";

const CombinedPayout = () => {
    const { idToken } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [payoutListData, setPayoutListData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [error, setError] = useState(null);

    const fetchPayoutLeaderboard = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${baseUrl}/account/user-payout-leaderboard/`, {
                headers: { Authorization: `Bearer ${idToken}` },
            });
            setPayoutListData(response.data);
            setError(null);
        } catch (error) {
            console.error("Error fetching payout list:", error);
            setError(error?.response?.data?.detail || "Failed to load leaderboard.");
        } finally {
            setLoading(false);
        }
    }, [idToken]);

    useEffect(() => {
        if (idToken) {
            fetchPayoutLeaderboard();
        }
    }, [idToken, fetchPayoutLeaderboard]);

    useEffect(() => {
        setCurrentPage(1);
    }, [payoutListData]);

    const combinedColumns = useMemo(
        () => [
            {
                Header: "Rank",
                accessor: "rank",
                Cell: ({ value }) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {value === 1 && <span style={{ marginRight: "5px", fontSize: "1.2em" }}>🥇</span>}
                        {value === 2 && <span style={{ marginRight: "5px", fontSize: "1.2em" }}>🥈</span>}
                        {value === 3 && <span style={{ marginRight: "5px", fontSize: "1.2em" }}>🥉</span>}
                        {value}
                    </div>
                )
            },
            { Header: "Name", accessor: "name" },
            { Header: "Total Payout", accessor: "total_payout" },
            {
                Header: "Country",
                accessor: "country",
                Cell: ({ value }) => {
                    const countryCode = resolveCountryCode(value);
                    const displayName = getDisplayCountryName(value);

                    return (
                        <div style={{ textAlign: "left", display: "flex", alignItems: "center", gap: "8px" }}>
                            {countryCode ? (
                                <ReactCountryFlag
                                    countryCode={countryCode}
                                    svg
                                    style={{
                                        width: "1.5em",
                                        height: "1.5em",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                    }}
                                    title={displayName}
                                />
                            ) : (
                                <div style={{ width: "1.5em", height: "1.5em" }} />
                            )}
                            <div>{displayName || "-"}</div>
                        </div>
                    );
                },
            },
        ],
        []
    );

    return (
        <div className="withdrawalHistory_container">
            {loading && <LoaderOverlay />}
            {error && <div className="no_data"><p>{error}</p></div>}
            <ReactTable
                data={payoutListData?.total_combined_payout_leaderboard || []}
                columns={combinedColumns}
                loading={loading}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />
        </div>
    );
};

export default CombinedPayout;
